export const RulersGuides = function (
  dragdrop,
  rootEl,
  parentEl,
  rWidth,
  rHeight,
  zoomInstance
) {
  'use strict'

  var hRuler = null,
    vRuler = null,
    xSnap = 0,
    ySnap = 0,
    mode = 2,
    guides = {},
    guidesCnt = 0,
    gUid = '',
    rulerStatus = 1,
    detailsStatus = 0,
    domDimensions = [],
    snapDom = 0,
    currentGuide = null,
    Ruler = function (type, size) {
      var ruler = document.createElement('div'),
        i = 0,
        span = document.createElement('span'),
        // label = null,
        // labelTxt = null,
        spanFrag = document.createDocumentFragment(),
        cnt = size

      ruler.className = 'ruler ' + type + ' unselectable'

      for (i; i < cnt; i++) {
        span = span.cloneNode(false)

        if (i === 0) {
          span.className = 'milestone'

          // if (i > 0) {
          //   label = span.cloneNode(false)
          //   label.className = 'label'

          //   if (i < 50) {
          //     label.className += ' l10'
          //   } else if (i >= 50 && i < 500) {
          //     label.className += ' l100'
          //   } else if (i >= 500) {
          //     label.className += ' l1000'
          //   }

          //   labelTxt = document.createTextNode(i)
          //   label.appendChild(labelTxt)
          //   span.appendChild(label)
          // }

          // span.className = 'milestone'
          // } else if (i % 5 === 0) {
          //   span.className = 'major'
        } else {
          span.className = ''
          span.removeAttribute('class')
        }

        spanFrag.appendChild(span)
      }

      ruler.appendChild(spanFrag)

      return ruler
    },
    getScrollPos = function () {
      var el = parentEl
      var t = Math.max(el.scrollTop, el.scrollTop),
        l = Math.max(el.scrollLeft, el.scrollLeft)

      return [t, l]
    },
    removeInboundGuide = function () {
      if (!currentGuide) {
        return
      }
      // var scrollPos = getScrollPos();
      // var vRuleBounds = vRuler.getBoundingClientRect();
      // var HRuleBounds = hRuler.getBoundingClientRect();

      // var hRemove = (currentGuide.offsetTop + HRuleBounds.top) < ((HRuleBounds.top + scrollPos[0]) + 30)
      // var vRemove = (currentGuide.offsetLeft + vRuleBounds.left) < ((vRuleBounds.left + scrollPos[1]) + 30)
      var hRemove = currentGuide.offsetTop <= 0
      var vRemove = currentGuide.offsetLeft <= 0

      if (hRemove && vRemove) {
        if (!currentGuide) {
          return
        }
        if (parentEl.contains(currentGuide)) {
          parentEl.removeChild(currentGuide)
        }
        delete guides[currentGuide]
        guidesCnt = guidesCnt - 1
        currentGuide = null
      }
    },
    deleteGuides = function () {
      var i
      if (guidesCnt > 0) {
        for (i in guides) {
          if (guides.hasOwnProperty(i)) {
            parentEl.removeChild(guides[i])
            delete guides[i]
            guidesCnt = guidesCnt - 1
          }
        }
      }
    },
    prepare = function () {
      setTimeout(function () {
        hRuler = new Ruler('h', rWidth)
        vRuler = new Ruler('v', rHeight)

        rootEl.appendChild(hRuler)
        rootEl.appendChild(vRuler)
      }, 10)
    }

  prepare()

  this.status = 1
  this.disable = function () {
    if (vRuler !== null) {
      deleteGuides()
      vRuler.style.display = 'none'
      hRuler.style.display = 'none'
    }

    rulerStatus = 0
    this.status = 0
  }

  this.enable = function () {
    if (vRuler !== null) {
      vRuler.style.display = 'block'
      hRuler.style.display = 'block'
    }
    rulerStatus = 1
    this.status = 1
  }

  window.addEventListener('mousedown', function (e, src) {
    if (zoomInstance.isPaused()) {
      return
    }
    var vRuleBounds = vRuler.getBoundingClientRect()
    var HRuleBounds = hRuler.getBoundingClientRect()
    var hitHRule = hRuler.contains(e.target)
    var hitVRule = vRuler.contains(e.target)

    var x = e.clientX,
      y = e.clientY,
      guide = null,
      guideInfo = null,
      guideInfoText = null,
      snap = 0

    var onHRule =
      x >= HRuleBounds.left &&
      (y > HRuleBounds.top - 20 && y < HRuleBounds.top + 20)

    var onVRule =
      y > vRuleBounds.top &&
      (x > vRuleBounds.left - 10 && x < vRuleBounds.left + 30)

    if (((onHRule && hitHRule) || (onVRule && hitVRule)) && rulerStatus === 1) {
      if (zoomInstance) {
        zoomInstance.pause()
      }

      guide = document.createElement('div')
      guideInfo = guide.cloneNode(false)
      guideInfoText = document.createTextNode('')

      gUid = 'guide-' + guidesCnt

      guideInfo.className = 'info'

      guideInfo.appendChild(guideInfoText)
      guide.appendChild(guideInfo)

      if (onHRule) {
        var _width = rWidth + 22 //rWidth * 2
        guide.className = 'guide h ruler-draggable'
        guide.style.top = y - HRuleBounds.top - 25 + 'px'
        // guide.style.width = `${_width}px`
        guide.style.width = `100%`
        // guide.style.left = '-20px' //(rWidth/2) - (_width/2) + 'px';
        guide.type = 'h'
        guideInfo.style.left = rWidth / 2 + 'px'
        snap = ySnap
        mode = 2
      } else if (onVRule) {
        var _height = rHeight + 22 //rHeight * 2
        guide.className = 'guide v ruler-draggable'
        guide.style.left = x - vRuleBounds.left - 25 + 'px'
        // guide.style.top = '-20px' //rHeight / 2 - _height / 2 + 'px'
        // guide.style.height = `${_height}px`
        guide.style.height = `100%`
        guide.type = 'v'
        guideInfo.style.top = _height / 2 + 'px'
        snap = xSnap
        mode = 1
      }

      guide.id = gUid
      guide.info = guideInfo
      guide.text = guideInfoText
      guide.x = 0
      guide.y = 0

      guides[gUid] = guide

      parentEl.appendChild(guide)

      dragdrop.set(guide, {
        mode: mode,
        onstart: function (elem) {
          if (zoomInstance) {
            zoomInstance.pause()
          }
          var text =
            elem.mode === 1
              ? parseInt(elem.style.left, 10) + 2
              : parseInt(elem.style.top, 10) + 2

          currentGuide = elem
          elem.text.nodeValue = text + 'px'
          elem.info.style.display = 'block'
        },
        onmove: function (elem) {
          var text = '',
            pos = 0,
            dims = [],
            len = 0,
            i = 0

          pos = elem.mode === 1 ? elem.style.left : elem.style.top
          pos = parseInt(pos, 10)

          if (snapDom === 1) {
            dims = domDimensions[elem.mode - 1]

            for (i, len = dims.length; i < len; i = i + 1) {
              if (pos <= dims[i]) {
                pos = dims[i]
                break
              }
            }
          }

          text = pos + 'px'
          let screen = document.querySelector("#root > section > section")

          if (elem.mode === 1) {
            elem.style.left = pos - 2 + 'px'
            elem.x = pos
            elem.style.border = pos == Math.floor(screen.clientWidth / 2) ? '1px solid #de4bfb' : 'none'
          } else {
            elem.style.top = pos - 2 + 'px'
            elem.y = pos
            elem.style.border = pos == Math.floor(screen.clientHeight / 2) ? '1px solid #de4bfb' : 'none'
          }

          elem.text.nodeValue = text
        },
        onstop: function (elem) {
          elem.info.style.display = 'none'
          if (zoomInstance) {
            zoomInstance.resume()
          }
          elem.style.border = 'none'
        },
        snap: snap
      })

      dragdrop.start(e, guide)

      guidesCnt = guidesCnt + 1
      setMouseUpEvents()
    }
  })

  function setMouseUpEvents() {
    window.addEventListener('mouseup', function () {
      if (zoomInstance) {
        zoomInstance.resume()
      }
      removeInboundGuide()
      if (detailsStatus === 1) {
        showDetailedInfo()
      }
    })
  }

  window.addEventListener('keyup', function (e) {
    if (e.ctrlKey === true && e.altKey === true) {
      switch (e.keyCode) {
        case 68:
          deleteGuides()
          break
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/lib/rulers.js